import React from 'react'
import './ProductCategories.css';
import PrimeryButton from '../../ControlledComponents/PrimeryButton/PrimeryButton';
import { useTranslation } from "react-i18next";


const ProductCategories = ({ selectedCategory, setSelectedCategory }) => {
  const { t ,i18n} = useTranslation();
  // include “All” so users can reset the filter
  const categoriesData = [
    t('categories.links.All'),
    t('categories.links.Documentaries'),
    t('categories.links.Commercials'),
    t('categories.links.Short Films'),
    t('categories.links.Corporate Videos'),
    t('categories.links.Videos Clip'),
  ];

  return (
    <div className="project-categories-section">
      {categoriesData.map((item) => (
        <PrimeryButton
          key={item}
          text={item}
          width="auto"
          height="40px"
          padding="5px 40px"
          fontSize="18px"
          lineHeight="22px"
          fontWeight="400"
          arrowTrue={false}
          isActive={selectedCategory === item}
          onClick={() => setSelectedCategory(item)}
        />
      ))}
    </div>
  );
};

export default ProductCategories;
